import _ from 'lodash'
import url from 'url'

/**
 * Enhances the functionality of the url module
 */
export default {

	/**
	 * Parses a query string into a hash of name/value pairs.
	 * @param {string} [urlString=window.location.search]
	 * @return {object} an empty object will be returned if there was no query string
	 */
	getQueryParams: function(urlString= window.location.search) {
		var u = urlString && url.parse(urlString, true)
		var requestParams = _.result(u, 'query', {})
		return requestParams
	},

	/**
	 * Same API as url.parse but safer.
	 * @param urlString
	 * @param {Boolean} [parseQueryString=false]
	 * 		also parse the query string using the querystring module
	 *
	 * @return {
	 *   hostname: Just the lowercased hostname portion of the host. Example: 'host.com'
	 *   pathname: The path section of the URL, that comes after the host and
	 *             before the query, including the initial slash if present.
	 *   query:    Either the 'params' portion of the query string, or a querystring-parsed object.
	 * }
	 */
	parse: function(urlString, parseQueryString= false) {
		var u = urlString && url.parse(urlString, parseQueryString)
		return {
			pathname: _.result(u, 'pathname'),
			hostname: _.result(u, 'hostname'),
			query: _.result(u, 'query', parseQueryString ? {} : '')
		}
	},

	hostname: function(fullUrl) {
		if (!fullUrl) {
			return ''
		}

		var hostname = this.parse(fullUrl).hostname
		if (!hostname) {
			hostname = fullUrl
		}

		return hostname
	}
}
